import axios from "axios";

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
})


export class DeliveryFeeRulesFetchAPI {

    //Function to get delivery fee rules
    static async getDeliveryFeeRules(business_id, branchoffice_id, channel, token) {
        let url = `/delivery-fees-rules?business_id=${business_id}`; 

        // If branchoffice_id is provided, add it to the URL
        if (branchoffice_id) {
            url += `&branchoffice_id=${branchoffice_id}`;
        }
        // If channel is provided, add it to the URL
        if (channel) {
            url += `&channel=${channel}`;
        }

        const res = await server(url, {
            method: "get",
            headers: { 'x-access-token': token }
        });
        return res;
    }

    //Function to get details of a delivery fee rule
    static async getDetailsDeliveryFeeRules(delivery_fee_rule_id, token) {
        const res = await server(`/delivery-fees-rules/${delivery_fee_rule_id}`, {
            method: "get",
            headers: { 'x-access-token': token }
        });
        return res;
    }

}